import { createAction } from 'redux-actions';

export const NAME = 'CLIENT.APP_SETTINGS.SET';
export default createAction(NAME);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/app-settings/update.js